import { adjustBrightness } from "./adjust-brightness";
import { adjustContrast } from "./adjust-contrast";
import { adjustHue } from "./adjust-hue";
import { adjustSaturation } from "./adjust-saturation";
import { adjustLevels } from "./adjust-levels";
import { adjustWhiteBalance } from "./adjust-white-balance";
import { adjustTemperature } from "./adjust-temperature";

export * from "./adjust-brightness";
export * from "./adjust-contrast";
export * from "./adjust-hue";
export * from "./adjust-saturation";
export * from "./adjust-levels";

export const webglSnippets = {
  adjustBrightness,
  adjustContrast,
  adjustHue,
  adjustSaturation,
  adjustLevels,
  adjustWhiteBalance,
  adjustTemperature,
} as const;
